import type { FC, PropsWithChildren } from "react";
import ToggleSwitch from "../ToggleSwitch";
import classes from "../../styles/NewTable.module.css";

export type TableStatusWithToggleProps = PropsWithChildren<{
  id?: string;
  checked?: boolean;
  status?: "Active" | "Inactive" | "Pending";
  onChange?: () => void;
  hideToggle?: boolean;
  toggleCustomStyle?: React.CSSProperties;
  disabled?: boolean;
  vertical?: boolean;
}>;

const TableStatusWithToggle: FC<TableStatusWithToggleProps> = ({
  id,
  status,
  onChange,
  checked,
  hideToggle,
  toggleCustomStyle,
  disabled = false,
  vertical = false,
}) => {
  const getStatusLabel = () => {
    switch (status) {
      case "Active":
        return "Active";
      case "Inactive":
        return "Inactive";
      case "Pending":
        return "Pending";
      default:
        return "";
    }
  };

  const getStatusClass = () => {
    switch (status) {
      case "Active":
        return classes.table__status_active;
      case "Inactive":
        return classes.table__status_deactive;
      case "Pending":
        return classes.table__status_pending;
      default:
        return "";
    }
  };

  return (
    <div
      className={classes.status_box}
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: vertical ? "column" : "row",
        gap: "1rem",
      }}
    >
      <p className={getStatusClass()}>{getStatusLabel()}</p>
      {!hideToggle && (
        <ToggleSwitch
          id={id}
          checked={checked}
          onChange={onChange}
          style={toggleCustomStyle}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default TableStatusWithToggle;
